type Props = {
  children: React.ReactNode;
  customFont?: boolean;
  heading?: boolean;
  lineClamp?: number;
  size?: 'default' | 'small' | 'medium' | 'big';
  styles?: string;
  titleBold?: boolean;
  titleUpperCase?: boolean;
  titleTracking?: string;
  color?: 'default' | 'black';
  height?: string;
};

export default function TitleH3({
  children,
  customFont = false,
  heading = true,
  size = 'default',
  styles = '',
  titleUpperCase = true,
  titleBold = false,
  titleTracking = '',
  color = 'default',
  height = '',
}: Props) {
  const textColor = color === 'black' ? 'text-neutral-900' : 'text-white';
  let textSize = size === 'default' ? 'text-lg lg:text-base' : 'text-lg';
  if (size === 'medium') {
    textSize = 'text-lg';
  }
  if (size === 'big') {
    textSize = 'text-xl md:text-3xl lg:text-4xl';
  }
  const customFontFamily = customFont
    ? `font-AgencyFBBlackComp antialiased ${titleTracking ? titleTracking : 'tracking-wider'}`
    : '';
  const uppercase = titleUpperCase ? 'uppercase' : '';
  const bold = titleBold && !customFont ? 'font-semibold' : '';
  const className = `relative ${textSize} ${customFontFamily} ${bold} ${uppercase} ${textColor} ${styles} ${height} ${titleTracking}`;

  if (!heading) {
    return <span className={className}>{children}</span>;
  }
  return <h3 className={className}>{children}</h3>;
}
